//@ts-nocheck
import { routingMixin } from "@jack-henry/web-component-router";
import { LitElement, css, html } from "lit";
import { customElement, property } from "lit/decorators.js";
import "./AddNewUserForm";
import { stringComparison } from "../../utils/app-utils";

@customElement("add-user")
export class AddNewUser extends routingMixin(LitElement) {
  static get is() {
    return "add-user";
  }
  static readonly styles = css`
    #addUserCon {
      padding: 25px;
      display: flex;
      flex-direction: column;
      flex: 1;
    }
    #btnCon {
      display: flex;
      flex-direction: row;
      gap: 15px;
    }
    jha-card {
      padding: 32px;
      overflow-y: scroll;
      margin-left: 0px;
      margin-right: 0px;
    }
  `;
  @property({ reflect: true, attribute: "profile-type" })
  profileType = "";

  @property({ type: Boolean })
  enableBeforeUnload = true;

  constructor() {
    super();
    // this.beforeUnloadHandler = this.beforeUnloadHandler.bind(this); //additional popup commented
  }

  async connectedCallback() {
    super.connectedCallback();
    window.addEventListener('beforeunload', this.beforeUnloadHandler);
    this.addEventListener('disable-unload-handler', this.disableBeforeUnloadHandler);
  }

  disableBeforeUnloadHandler() {
    this.enableBeforeUnload = false;
  }

  // Unsaved Stay/Leave is on add-new-user-form.onCancelClick (no throw). Do not re-enable
  // this by throwing from a shell handler — Stay is a normal outcome.
  //  async routeExit(currentNode, nextNode, routeId, context) { // commented because its effecting Cancel func
  //   this.disableBeforeUnloadHandler();
  //   const form = this.shadowRoot.querySelector('add-new-user-form');
  //   if (form && form.formDirty) {  
  //     try{
  //       await this.onCancelClick();
  //       this.enableBeforeUnload = false;
  //       const router = new Router(routerConfig);
  //       router.go(context.path);
  //     } catch (error) {
  //       this.enableBeforeUnload = true;
  //       history.pushState(null, '', location.href);
  //       history.back();
  //     }  
  //   } else {
  //     this.enableBeforeUnload = false;
  //     const router = new Router(routerConfig);
  //     router.go(context.path);
  //   }
  //   sessionStorage.removeItem('add-new-user-form');
  //   this.disableBeforeUnloadHandler();
  // }

  disconnectedCallback() {
    // window.removeEventListener('beforeunload', this.beforeUnloadHandler); additional popup commented
    super.disconnectedCallback();
  }

  beforeUnloadHandler(event: BeforeUnloadEvent) {
    // if (this.enableBeforeUnload) {additional popup commented
    //   event.preventDefault();
    //   event.returnValue = '';
    // }
  }

  // pause(ms: number): Promise<void> { commented un used code for code coverage
  //   return new Promise(resolve => setTimeout(resolve, ms));
  // }

  render() {
    return html`
      <div id="addUserCon">
        <h1>
          ${stringComparison(this.profileType, "destination")
        ? "Add Destination User"
        : "Add Regular User"}
        </h1>
        <jha-card>
          <add-new-user-form
            .addProfType=${this.profileType}
          ></add-new-user-form>
        </jha-card>
      </div>
    `;
  }
}
declare global {
  interface HTMLElementTagNameMap {
    "add-user": AddNewUser;
  }
}
